import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { useDebounce } from 'react-use';
import {
  Button,
  Card,
  Form,
  Row,
  Col,
} from "react-bootstrap";

import Worksheet from 'components/Worksheet/Worksheet';
import InputTable from './InputTable.js';
import useNotif from 'hooks/use-notify-hook';
import InputFormula from './InputFormula.js';
import QuestionContext from '../Utils/context';
import { ACTIONS } from '../Utils/action';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';

export default function Question({
  index,
  scores,
  questionTypes,
  QUESTION_ID,
  QUESTION_CODE,
  QUESTION_LABEL,
  QUESTION_DESC,
  QUESTION_TYPE_ID,
  SQL_TEXT,
  FORMULA,
  JSON_TABLE,
  CELL_FORMULA,
  disabled
}) {

  const context = useContext(QuestionContext);
  const [swal, setSwal] = useAlert();
  const [notif, dispatchNotif] = useNotif();
  const [bullet, setBullet] = useState(QUESTION_CODE);
  const [label, setLabel] = useState(QUESTION_LABEL);
  const [description, setDescription] = useState(QUESTION_DESC || '');

  /**
   * Debouncehr saving on change
   *
   */

  console.log('Ini adalah disable question');
  const [, cancelLabel] = useDebounce(async () => {

    if (!QUESTION_ID) return;

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
      { QUESTION_LABEL: label },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        }
      }
    );

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

    context.dispatchQuestions({
      type: ACTIONS.EDIT,
      payload: {
        QUESTION_ID: QUESTION_ID,
        QUESTION_LABEL: response.data.QUESTION_LABEL,
      }
    });

  }, 2000, [label]);

  const [, cancelBullet]  = useDebounce(async () => {

    if (!QUESTION_ID) return;

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
      { QUESTION_CODE: bullet },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        }
      }
    );

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

    context.dispatchQuestions({
      type: ACTIONS.EDIT,
      payload: {
        QUESTION_ID: QUESTION_ID,
        QUESTION_CODE: response.data.QUESTION_CODE,
      }
    });


  }, 2000, [bullet]);

  const [, cancelDescription] = useDebounce(async () => {

    if (!QUESTION_ID) return;

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
      { QUESTION_DESC: description },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        }
      }
    );

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

    context.dispatchQuestions({
      type: ACTIONS.EDIT,
      payload: {
        QUESTION_ID: QUESTION_ID,
        QUESTION_DESC: response.data.QUESTION_DESC,
      }
    });
  }, 2000, [description]);

  /**
   * Question CRUD handler
   *
   */
  const handleDelete = async () => {

    const handleSuccessCallback = async () => {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
          }
        }
      );

      context.dispatchQuestions({
        type: ACTIONS.DELETE,
        payload: {
          QUESTION_ID: QUESTION_ID,
        }
      });
    }

    setSwal({
      type: TYPES.CONFIRM,
      payload: {
        title: `Are you sure?`,
        message: `You are about to delete "Question # ${index}" question.`,
        onSuccess: {
          title: `Success`,
          message: `Delete Success`,
          callback: handleSuccessCallback,
        }
      }
    });
  }

  const handleTypeChange = async ({ target: { value }}) => {

    if (!QUESTION_ID) return;

    const nullable = {
      FORMULA: null,
      SQL_TEXT: null,
      JSON_TABLE: null,
    };

    const payload = {
      ...nullable,
      QUESTION_ID: QUESTION_ID,
      QUESTION_TYPE_ID: value,
    }

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`,
        }
      }
    );

    context.dispatchQuestions({
      type: ACTIONS.EDIT,
      payload: response.data,
    })
  }

  /**
   * Formula question type handler
   *
   */
  const getType = (id) => {

    switch (parseInt(id)) {
      case 2:
        return (
          <InputFormula
            {...{
              scores,
              QUESTION_ID,
              FORMULA,
              SQL_TEXT,
              disabled
            }}
          />
        );
      case 3:
        return (
          <InputTable
            {...{
              scores,
              QUESTION_ID,
              JSON_TABLE,
              dispatchNotif,
              CELL_FORMULA,
              disabled
            }}
          />
        );

      default:
        return null;
    }
  }

  useEffect(() => {
    cancelBullet();
    cancelLabel();
    cancelDescription();
  }, []);

  return (
    <Row>
      <Col md="12">
        {notif}
        {swal}
        <Card>
          <Card.Header>
            <Card.Title as="h4">Question #{index}</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="10">
                <Row>
                  <Col md="2">
                    <Form.Group>
                      <Form.Label>Bullet</Form.Label>
                      <Form.Control
                        value={bullet}
                        disabled={disabled}
                        onChange={({target: {value}}) => setBullet(value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="10">
                    <Form.Group>
                      <Form.Label>Label</Form.Label>
                      <Form.Control
                        value={label}
                        disabled={disabled}
                        onChange={({target: {value}}) => setLabel(value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="questionDesc">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    value={description}
                    disabled={disabled}
                    onChange={({target: {value}}) => setDescription(value)}
                    isInvalid={description.length > 4000}
                    as="textarea"
                    rows={4}
                  />
                   <Form.Text id="passwordHelpBlock" muted>
                    Total characters: {description.length} / 4000
                  </Form.Text>
                </Form.Group>
                {getType(QUESTION_TYPE_ID)}
              </Col>
              <Col md="2">
                <Form.Group>
                  <Form.Label>Question Type</Form.Label>
                  {QUESTION_TYPE_ID && questionTypes && (
                    <Form.Control
                      value={QUESTION_TYPE_ID}
                      disabled={disabled}
                      onChange={handleTypeChange}
                      as="select"
                    >
                      {questionTypes.map((type, key) => (
                        <option key={key} value={type.QUESTION_TYPE_ID}>{type.QUESTION_TYPE_NAME}</option>
                      ))}
                    </Form.Control>
                  )}
                </Form.Group>
                {!disabled && (
                  <Form.Group>
                    <Button onClick={handleDelete} variant="danger">Delete</Button>{' '}
                  </Form.Group>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}